import Ajv from "ajv";

import { lvtResponseSchema } from "../common";

// TODO: do the schema
const presetImagesProperties = {
    datetimeRecorded: { type: "string" },
    imageUrl: { type: "string" },
    thumbUrl: { type: ["string", "null"] },
    presetId: { type: "integer" },
};

const presetImageSchema = {
    type: "object",
    additionalProperties: false,
    required: Object.keys(presetImagesProperties),
    properties: presetImagesProperties,
};

const presetImagesSchema = {
    type: "array",
    items: presetImageSchema,
    uniqueItems: true,
};

export const presetImagesValidator = new Ajv().compile(presetImagesSchema);

const lvtResponsePrestImagesSchema = lvtResponseSchema(presetImagesSchema);

// TODO: actually do this
export const lvtResponsePresetImagesValidator = new Ajv().compile(lvtResponsePrestImagesSchema);
